module.exports = __webpack_public_path__ + "static/media/ehealth_50x_coins_banner_mobile.be8e077c.jpg";